import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import ExpensesAnalytics from '@/components/expenses/ExpensesAnalytics';
import ExpensesRecords from '@/components/expenses/ExpensesRecords';
import AddExpenseSheet from '@/components/expenses/AddExpenseSheet';

export default function Expenses() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const [selectedExpenseId, setSelectedExpenseId] = useState<number | null>(null);

  const handleAddExpense = () => {
    setSelectedExpenseId(null);
    setSheetOpen(true);
  };

  const handleEditExpense = (expenseId: number) => {
    setSelectedExpenseId(expenseId);
    setSheetOpen(true);
  };

  return (
    <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
      <div className="mb-8 flex items-start justify-between">
        <div>
          <h1 className="text-4xl font-semibold tracking-tight mb-2">Expenses</h1>
          <p className="text-muted-foreground">Track all business expenditures and costs.</p>
        </div>
        <Button onClick={handleAddExpense} className="shrink-0">
          <Plus className="h-4 w-4 mr-2" />
          Add Expense
        </Button>
      </div>

      <Tabs defaultValue="analytics" className="space-y-6">
        <TabsList>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
          <TabsTrigger value="records">Records</TabsTrigger>
        </TabsList>

        <TabsContent value="analytics">
          <ExpensesAnalytics />
        </TabsContent>

        <TabsContent value="records">
          <ExpensesRecords onEditExpense={handleEditExpense} />
        </TabsContent>
      </Tabs>

      <AddExpenseSheet
        open={sheetOpen}
        onOpenChange={setSheetOpen}
        expenseId={selectedExpenseId}
      />
    </div>
  );
}
